import future_mobi from "../../../assets/images/future_mobi.webp";
import future_pc from "../../../assets/images/future_pc.webp";

export default function BusinessFuture() {
  return (
    <div className="w-full grid grid-cols-1 container mx-auto p-3 lg:flex lg:gap-10 glg:px-[120px] lg:items-center lg:justify-center py-[40px]">
      <div className="w-full ">
        <img
          src={future_mobi}
          alt="fu"
          className="max-w-full h-auto block md:hidden lg:hidden"
        />
        <img
          src={future_pc}
          alt="f"
          className="max-w-full h-auto hidden md:block lg:block"
        />
      </div>
      <div className="w-full flex flex-col gap-1 lg:flex-col lg:gap-6 ">
        <p className="text-xl md:text-2xl lg:text-3xl font-semibold text-[#033F6A]">
          Cùng nhau xây dựng tương lai
        </p>
        <p className="text-sm md:text-base font-normal text-[#333333] lg:w-[497px]">
          BlueSkyIT tự hào hợp tác cùng các đối tác chiến lược trên toàn thế
          giới để mang lại những giá trị tốt nhất cho khách hàng và cộng đồng.
          Sự hợp tác này giúp chúng tôi không ngừng cải tiến và phát triển các
          giải pháp công nghệ tiên tiến
        </p>
      </div>
    </div>
  );
}
